import React from 'react';

import { Control, Panel, useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import styles from './vmsPage.module.scss';
import { VmsSettingModal } from './VmsSettingModal';
import VmsListTable from './VsmListTable';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';

const VmsPage = () => {
  const { t } = useTranslation();
  const settingModal = useModal();

  return (
    <Page>
      <PageContent>
      <Panel className="PanelAutoHeight">
        {settingModal.wrap(<VmsSettingModal close={settingModal.close} />)}
        <div className={styles.vmsPageWrapper}>
          <div className={styles.settings}>
            <Control.Button onClick={settingModal.open}>
              {t('vms:table.settings')}
            </Control.Button>
          </div>
          <VmsListTable />
        </div>
      </Panel>
      </PageContent>
    </Page>
  );
};

VmsPage.defaultProps = {
};

export default connect(() => ({
}), () => ({
}))(VmsPage);
